export default __webpack_public_path__ + "static/summer_containers4-dbcf355b238dd4a08b0d5d73bd83d0d0.webp";